// TODO move to global context
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { EOpenSidebar } from '@/constants/sidebar'

interface Window {
  width: number
  height: number
}

interface Data {
  window: Window
}

interface Methods {
  handleResize: () => void
}

interface Computed {
  openSidebar: EOpenSidebar | false
  isShowSettings: boolean
  isShowKnowledge: boolean
  isDesktop: boolean
  isTablet: boolean
  isMobile: boolean
}

const TABLET_BREAKPOINT = 1600
const TABLET_BREAKPOINT_WITH_OPEN_SIDEBAR = 1350
const MOBILE_BREAKPOINT = 920

export default Vue.extend<Data, Methods, Computed, {}>({
  data() {
    return {
      window: {
        width: 0,
        height: 0,
      },
    }
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },
  },
  computed: {
    ...mapGetters({
      openSidebar: 'getOpenSidebar',
    }),
    isShowSettings(): boolean {
      return this.openSidebar === EOpenSidebar.Settings
    },
    isShowKnowledge(): boolean {
      return this.openSidebar === EOpenSidebar.Knowledge
    },
    isDesktop(): boolean {
      const tabletBreakpoint = this.openSidebar
        ? TABLET_BREAKPOINT
        : TABLET_BREAKPOINT_WITH_OPEN_SIDEBAR
      return this.window.width > tabletBreakpoint
    },
    isTablet(): boolean {
      return this.window.width > MOBILE_BREAKPOINT
    },
    isMobile(): boolean {
      return !this.isDesktop && !this.isTablet
    },
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
})
